module.exports = __webpack_public_path__ + "img/ree_token.brpg.4169670.png";